import { render, staticRenderFns } from "./RegulationRequirementItem.vue?vue&type=template&id=4c71e8d4&scoped=true&"
import script from "./RegulationRequirementItem.vue?vue&type=script&lang=js&"
export * from "./RegulationRequirementItem.vue?vue&type=script&lang=js&"
import style0 from "./RegulationRequirementItem.vue?vue&type=style&index=0&id=4c71e8d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c71e8d4",
  null
  
)

export default component.exports